export default __webpack_public_path__ + "static/media/star-disabled.4133cbd7.svg";